/**
 * Error code for fetch error
 * @type {string}
 */
export const FETCH_ERROR = 'OBS_FETCH_ERROR';

/**
 * Types we don't want in logs
 * @type {string[]}
 */
export const UNACCEPTABLE_TYPES = [ 'function' ];

/**
 * Values we don't want in logs
 * @type {string[]}
 */
export const UNWANTED_VALUES = [ '', null, undefined, '{}' ];

/**
 * Types we needn't change in logs
 * @type {string[]}
 */
export const PRIMITIVE_TYPES = [ 'string', 'number', 'boolean' ];

/**
 * Delay requests to allow browser to collect another metric
 * @type {number}
 */
export const PERFORMANCE_PAYLOAD_SEND_TIMEOUT = 500;
